import React from "react";
import Script from "react-load-script";
import { useDispatch } from "react-redux";
import {
  hcaptchaEnabled,
  recaptchaEnabled,
} from "../../form-store/captcha-reducer";

const Recaptcha = ({ children }) => {
  const dispatch = useDispatch();
  
  const handleScriptLoad = (data) => {
    console.log("Recaptcha loaded successfully");
    dispatch(recaptchaEnabled());
  };

  const handleScriptError = (err) => {
    console.log("Recaptcha error", err);
    dispatch(hcaptchaEnabled());
  };

  return (
    <>
      {children}
      <Script
        url={`https://www.recaptcha.net/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`}
        onLoad={handleScriptLoad}
        onError={handleScriptError}
      />
    </>
  );
};

export default Recaptcha;
